"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.errorsNamespace = 'file2html.errors';



//////////////////
// WEBPACK FOOTER
// ./node_modules/file2html-fiction-book/node_modules/file2html/lib/errors.js
// module id = 656
// module chunks = 0